// extracted by mini-css-extract-plugin
export var redoItem = "_og-1";
export var redoTrigger = "_og-0";